import { string, object, array, Infer } from 'myzod';

export const WelcomeScreenSchema = object({
  account_name: string(),
  account_small_logo: string(),
  aggregate_id: string(),
  confidentiality_content: object({
    message: string(),
    subject: string(),
  }),
  privacy_policy: string(),
  product_type: string(),
  raw_data_extract_warning: string().nullable(),
  secret: string().nullable(),
  start_path: string(),
  survey_logo: string().nullable(),
  survey_name: string(),
  supported_locales: array(
    object({
      name: string(),
      code: string(),
    })
  ),
  threesixty_name: string(),
  welcome_screen_locale: object({
    name: string(),
    code: string(),
  }),
  welcome_content: string().nullable(),
});

export type WelcomeScreenProps = Infer<typeof WelcomeScreenSchema>;
